import React from 'react'

const Coin = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_241_2513)">
        <path d="M8.9375 15.4554C9.061 17.0056 10.2863 18.213 12.4833 18.356V19.5H13.4582V18.3479C15.7332 18.1886 17.0625 16.9731 17.0625 15.2084C17.0625 13.6045 16.0452 12.7774 14.2269 12.3484L13.4582 12.1664V9.05125C14.4332 9.16175 15.054 9.69475 15.2035 10.4325H16.913C16.7895 8.93913 15.509 7.77075 13.4582 7.644V6.5H12.4833V7.66837C10.5414 7.8585 9.217 9.02688 9.217 10.6795C9.217 12.142 10.2017 13.0715 11.8381 13.4534L12.4833 13.6126V16.9179C11.4839 16.7668 10.8225 16.2191 10.673 15.4554H8.9375ZM12.4751 11.9356C11.5164 11.713 10.9964 11.2596 10.9964 10.5771C10.9964 9.81337 11.557 9.24138 12.4833 9.074V11.934H12.4751V11.9356ZM13.5996 13.8743C14.7648 14.144 15.3026 14.5811 15.3026 15.353C15.3026 16.2338 14.6331 16.8383 13.4582 16.9488V13.8417L13.5996 13.8743Z"
              fill="#4AA652"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 24.375C16.0168 24.375 18.9101 23.1766 21.0433 21.0433C23.1766 18.9101 24.375 16.0168 24.375 13C24.375 9.98316 23.1766 7.08989 21.0433 4.95666C18.9101 2.82343 16.0168 1.625 13 1.625C9.98316 1.625 7.08989 2.82343 4.95666 4.95666C2.82343 7.08989 1.625 9.98316 1.625 13C1.625 16.0168 2.82343 18.9101 4.95666 21.0433C7.08989 23.1766 9.98316 24.375 13 24.375ZM13 26C16.4478 26 19.7544 24.6304 22.1924 22.1924C24.6304 19.7544 26 16.4478 26 13C26 9.55219 24.6304 6.24558 22.1924 3.80761C19.7544 1.36964 16.4478 0 13 0C9.55219 0 6.24558 1.36964 3.80761 3.80761C1.36964 6.24558 0 9.55219 0 13C0 16.4478 1.36964 19.7544 3.80761 22.1924C6.24558 24.6304 9.55219 26 13 26Z"
          fill="#4AA652"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 21.9375C15.3704 21.9375 17.6437 20.9959 19.3198 19.3198C20.9959 17.6437 21.9375 15.3704 21.9375 13C21.9375 10.6296 20.9959 8.35634 19.3198 6.68023C17.6437 5.00413 15.3704 4.0625 13 4.0625C10.6296 4.0625 8.35634 5.00413 6.68023 6.68023C5.00413 8.35634 4.0625 10.6296 4.0625 13C4.0625 15.3704 5.00413 17.6437 6.68023 19.3198C8.35634 20.9959 10.6296 21.9375 13 21.9375ZM13 22.75C14.2804 22.75 15.5482 22.4978 16.7312 22.0078C17.9141 21.5178 18.9889 20.7997 19.8943 19.8943C20.7997 18.9889 21.5178 17.9141 22.0078 16.7312C22.4978 15.5482 22.75 14.2804 22.75 13C22.75 11.7196 22.4978 10.4518 22.0078 9.26884C21.5178 8.08591 20.7997 7.01108 19.8943 6.10571C18.9889 5.20034 17.9141 4.48216 16.7312 3.99217C15.5482 3.50219 14.2804 3.25 13 3.25C10.4141 3.25 7.93419 4.27723 6.10571 6.10571C4.27723 7.93419 3.25 10.4141 3.25 13C3.25 15.5859 4.27723 18.0658 6.10571 19.8943C7.93419 21.7228 10.4141 22.75 13 22.75Z"
          fill="#4AA652"
        />
      </g>
      <defs>
        <clipPath id="clip0_241_2513">
          <rect
            width="26"
            height="26"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Coin;
